import { date } from "@/_shared/utils";

export const useDatesHelper = {
  computed: {
    hasWorkShiftToday() {
      const currentDate = date.getLocaleCurrentDay();
      return this.calendarDates.includes(currentDate);
    },
    workDayWasCompleted() {
      const currentDate = new Date;
      const deadlineDate = new Date;
      deadlineDate.setHours(22, 0, 0);
      return !!(currentDate > deadlineDate);
    },
    startTime() {
      return date.getTimeFromDate(this.startDate);
    },
    endTime() {
      return date.getTimeFromDate(this.endDate);
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/work-shift-menu/useDatesHelper.js